import React from 'react';
import { InstagramEmbed as Insta } from 'react-social-media-embed';

export const InstagramEmbed = ({ url }) => <Insta url={url} width={328} />;
